export const approvalPersonSortFields = ['peopleName', 'date', 'projectName', 'senderName'];

export const approvalProjectSortFields = ['position', 'date', 'townName', 'senderName'];

export const requestSortFields = ['position', 'date', 'townName', 'senderName'];

export const defaultSort = {
    firstField: 'date',
    firstOrder: 'dec'
};
